export const PAGE_TITLES = {
  DEFAULT: 'myVViD'
};
